import React, { useEffect } from 'react';
import { Alert } from 'shards-react';
import InformationList from './InformationList';
import useUserRoles from '../../../../hooks/useUserRoles';
import { RootState, useDispatch, useSelector } from '../../../../redux/store';
import { getTradingCompanyOptions } from '../../../../redux/slices/options';
import { getTradingCompanyInformations, hideTradingCompanyInformation } from '../../../../redux/slices/tradingCompanyInformation';

const TradingCompanyInformation = (): React.ReactElement => {
  const dispatch = useDispatch();
  const { isAdmin } = useUserRoles();
  const { tradingCompany } = useSelector((state: RootState) => state.options);
  const { tradingCompanyInformations, displayTradingCompanyInformations } = useSelector((state: RootState) => state.tradingCompanyInformation);
  const { informations } = useSelector((state: RootState) => state.manageTradingCompanyInformation);

  // SIDE EFFECT
  // ================================================================================

  useEffect(() => {
    if (displayTradingCompanyInformations) {
      dispatch(getTradingCompanyOptions());
      dispatch(getTradingCompanyInformations());
    }
  }, []);

  useEffect(() => {
    if (isAdmin) {
      dispatch(getTradingCompanyInformations());
    }
  }, [informations]);

  // EVENT HANDLER
  // ================================================================================

  const dismiss = (): void => {
    dispatch(hideTradingCompanyInformation());
  };

  // VIEW
  // ================================================================================

  return (
    <>
      {tradingCompanyInformations && tradingCompanyInformations.length > 0 && displayTradingCompanyInformations && (
        <Alert className="pl-4" theme="danger" dismissible={dismiss}>
          <InformationList informations={tradingCompanyInformations} tradingCompany={tradingCompany} />
        </Alert>
      )}
    </>
  );
};
export default TradingCompanyInformation;
